// extracted by mini-css-extract-plugin
export default {"autocomplete-product":"styles_autocomplete-product__J9eFC"};